import { render, staticRenderFns } from "./exhibitionDetail.vue?vue&type=template&id=2f9e8f3e&scoped=true"
import script from "./exhibitionDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./exhibitionDetail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./exhibitionDetail.vue?vue&type=style&index=0&id=2f9e8f3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9e8f3e",
  null
  
)

export default component.exports